import React from "react";
import styles from "./RankChart.module.scss";
import Text from "components/Text/Text"
interface IColumn {
  headerName?: string;
}

interface IRankChart {
  columns: IColumn [];
  data: any;
  isLoading: boolean;
  headerTitle: string;
  customHeader?: React.ReactNode;
  onRowClick?: (e:any) => void;
  subHeader?: React.ReactNode;
}


const RankChart:React.FC<IRankChart> = ({ 
  data, 
  headerTitle,
  customHeader,
  subHeader,
  onRowClick
}) => {
  
  return (
    <div className={styles.tableWrapper}>
      <div className={styles.headerTitle}><Text type="header">{headerTitle}</Text></div>
      <div className={styles.customHeader}>{customHeader}</div>
      {(subHeader) && <div className={styles.subHeader}>{subHeader}</div>}

      <table className={styles.table}>
        <thead className={styles.thead}>
          <tr className={styles.tr}>
            <th className={styles.thead}><Text type="secondary">Practitioner Name</Text></th>
            <th className={styles.thead}><Text type="secondary">Revenue Delta</Text></th>
            <th className={styles.thead}><Text type="secondary">Revenue LTM</Text></th>
            <th className={styles.thead}><Text type="secondary">Revenue Prior LTM</Text></th>
            <th className={styles.thead}><Text type="secondary">Distributor Delta</Text></th>
            <th className={styles.thead}><Text type="secondary">Priority</Text></th>
          </tr>
        </thead>
        <tbody>
          {data.map((item: any, index: number) => (
            <tr 
              onClick={onRowClick}
              className={styles.tr} key={index}>
              <td className={styles.td} data-label="Revenue Delta"><Text>{item.practitionerName}</Text></td>
              <td className={styles.td} data-label="Revenue Delta"><Text type='currency'>{item.revenueDelta}</Text></td>
              <td className={styles.td} data-label="Revenue LTM"><Text type='currency'>{item.revenueLtm}</Text></td>
              <td className={styles.td} data-label="Revenue Prior LTM"><Text type='currency'>{item.revenuePrior}</Text></td>
              <td className={styles.td} data-label="Distributor Delta"><Text type='currency'>{item.distributorDelta}</Text></td>
              <td className={styles.td} data-label="Priority"><Text>{item.priority}</Text></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default RankChart;